exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "manager-year-inline{display:block}manager-year-inline calendar-inline{min-height:10px}manager-year-inline calendar-inline-paginator .subtitle{display:none}manager-year-inline calendar-inline-card{position:relative;top:1px}manager-year-inline .container-hide-info-btn{width:134px;height:40px;padding-left:10px;border-bottom:1px solid #f9f9f9;border-left:1px solid #f9f9f9}manager-year-inline td{max-height:60px}manager-year-inline .calendar-inline-row{margin-bottom:7px}manager-year-inline .content{display:flex}manager-year-inline .calendars{position:relative;overflow-x:auto;margin-left:65px}manager-year-inline .cards{max-width:170px}manager-year-inline .cards.hidden-cards{max-width:5px}manager-year-inline .card{margin-bottom:9px}manager-year-inline .card .remark-container{position:relative;z-index:99}manager-year-inline .card .remark-container .remark{position:absolute;top:10px;left:49px;display:block;color:#c8175e;border-radius:10px;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.scss
// module id = 1295
// module chunks = 0